import styled from 'styled-components';

export const Content = styled.div`
  padding-left: 10px;
  padding-right: 10px;
`;

export const ViewFooterTotal = styled.div`
  background-color: #fff;
  padding-right: 10px;
  padding-left: 10px;
  font-size: 20px;
`;

export const Title = styled.b`
  align-items: center;
  text-align: center;
  justify-content: center;
  font-size: 20px;
  display: flex;
`;

export const ItemSectionTitle = styled.b`
  display: flex;
  margin-bottom: 10px;
  font-size: 16px !important;
  margin: 10px 10px 4px !important;
  flex: 1 !important;
  color: #000000;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  font-weight: 700;
`;

export const ProdutoDescricao = styled.b`
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  justify-content: space-between;
`;

export const Observacao = styled.b`
  display: flex;
  padding-left: 25px;
`;

export const SectionTitle = styled.b`
  text-align: left;
  font-size: 16px;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
`;

export const SectionBody = styled.div`
  padding-left: 20px;
`;

export const Description = styled.div`
  display: flex;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
  font-size: 16px;
`;

export const DescriptionBold = styled.div`
  display: flex;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const ItemFooterPagamento = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin: 8px 0px;
  font-size: 16px;
`;

export const ContentLoading = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const LineSeparator = styled.div`
  border: 1px solid #000;
  width: 100%;
`;

export const Cep = styled.div`
  color: #000000;
  margin-left: 10px;
  font-size: 20px;
`;

export const SubmitButton = styled.button`
  position: fixed;
  width: 130px !important;
  border-color: #25d366;
  height: 40px;
  bottom: 40px;
  right: 15px;
  background-color: #25d366;
  color: #fff;
  border-radius: 8px;
  text-align: center;
  -webkit-box-shadow: 1px 1px 5px #888;
  box-shadow: 1px 1px 5px #888;
`;
